import React from "react";
import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { generateBreadcrumbLink } from "./functions/breadcrumbLinkGeneration";

const BreadCrumb = ({
  title,
  pageTitle,
  moduleTitle = "",
  showBreadcrumb = true,
}) => {
  const roleName = localStorage.getItem("roleName");

  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          <div className="page-title-box d-sm-flex align-items-center justify-content-between rv-breadcrumb-border">
            <h4 className="mb-sm-0 rv-text-primary-color">
              {moduleTitle ? moduleTitle : title}
            </h4>

            {showBreadcrumb && roleName !== "Customer" && (
              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">
                    {generateBreadcrumbLink(pageTitle, title) !== "" ? (
                      <Link to={generateBreadcrumbLink(pageTitle, title)}>
                        {moduleTitle ? moduleTitle : pageTitle}
                      </Link>
                    ) : (
                      <>{moduleTitle ? moduleTitle : pageTitle}</>
                    )}
                  </li>

                  <li className="breadcrumb-item active">{title}</li>
                </ol>
              </div>
            )}
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default BreadCrumb;
